import http from '@/http'
import SystemNotification from '@/store/models/SystemNotification'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'system_notifications/'

const defaultState = () => {
  return {
    pagination: {}
  }
}

const state = defaultState()

const getters = {
  pagination: state => state.pagination
}

const mutations = {
  pagination(state, payload) {
    state.pagination = payload
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
  async index({ state, commit }, payload = {}) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    if (!payload?.page && state.pagination.current) {
      payload.page = state.pagination.current
    }
    await http({
      url: tmpURL + API_PATH + serializeObjectToQueryParameter(payload)
    }).then(response => {
      SystemNotification.deleteAll()
      SystemNotification.insert({
        data: response.data.data.map(resource => resource.attributes)
      })
      commit('pagination', response.data.pagination)
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async show({ commit }, id) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    await http({
      url: tmpURL + API_PATH + id
    }).then(response => {
      SystemNotification.insert({
        data: Object.assign(response.data.data.attributes, {
          systemNotificationItems: response.data.included.filter(resource => resource.type === 'systemNotificationItem')
                                                         .map(resource => resource.attributes)
        })
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
